// extracted by mini-css-extract-plugin
export default {"ErrorMessageBox":"components-page-CreateWorkTimeEntryPage-__ErrorMessageBox"};